import { getPreselectedLanguageCode } from './getPreseletedLanguageCode';
export const detectLanguage = (languages, defaultLng = {}, jurisdictionId) => {
    const { defaultLanguageCode } = getPreselectedLanguageCode(jurisdictionId);
    if (!defaultLanguageCode) {
        return defaultLng;
    }
    return languages[defaultLanguageCode] || defaultLng;
};
//# sourceMappingURL=detectLanguage.js.map